import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { DocumentIntelligenceRoutingModule } from './document-intelligence-routing.module';
import { ModelsListComponent } from './models-list/models-list.component';
import { RequestsListComponent } from './requests-list/requests-list.component';
import { ModelComponent } from './model/model.component';

@NgModule({
  imports: [
    CommonModule,
    DocumentIntelligenceRoutingModule,
    NgxPaginationModule,
    SharedModule,
    ReactiveFormsModule
  ],
  declarations: [
    ModelsListComponent,
    RequestsListComponent,
    ModelComponent
  ],
  entryComponents: [
    ModelComponent,
  ]
})
export class DocumentIntelligenceModule { }
